__turbopack_context__.v({
  "errorSection": "vOe_nq_errorSection",
  "img": "vOe_nq_img",
  "magnifyingGlassIcon": "vOe_nq_magnifyingGlassIcon",
  "myEvalsHeader": "vOe_nq_myEvalsHeader",
  "noResultsIcon": "vOe_nq_noResultsIcon",
  "root": "vOe_nq_root",
  "serviceMessage": "vOe_nq_serviceMessage",
});
